import React, {Component} from "react"
import {injectIntl} from 'react-intl'
import {convertToDisplayFormat} from '../../../util/DateUtil'
import {DATE_CHART_FORMAT} from '../../../constants'

const tableId = 'LicenseDetailsTable'


const getData = (details, format) => {

  return details.map((it) => {
    return [
      it.limit,
      convertToDisplayFormat(it.dateCreated, DATE_CHART_FORMAT),
      convertToDisplayFormat(it.startDate, DATE_CHART_FORMAT),
      convertToDisplayFormat(it.expirationDate, DATE_CHART_FORMAT),
    ]
  })


}

class LicenseDetailsTable extends Component {

  componentDidMount() {

    const details = this.props.details || []
    const format = this.props.intl.formatMessage

    const tableData = getData(details, format)
    $('#' + tableId).DataTable({
      data: tableData,
      order: [[1, 'desc']],
      info: false,
      paging: false,
      searching: false,
      lengthChange: false,
      responsive: true,
      "columnDefs": [{
        targets:0,
        data:null,
        render: (data, type, row)=>{

          const value = data[0]
          if(type === 'display'){
            return format({id: `desc.table.licenses.details`}, {limit: value})
          }else
            return value
        }
      }]
    });

  }

  componentWillReceiveProps(nextProps) {
    const details = this.props.details || []
    const format = this.props.intl.formatMessage

    const data = getData(details, format)
    $('#' + tableId).DataTable().clear()
    $('#' + tableId).DataTable().rows.add(data).draw()
  }

  render() {
    return (
      <table width="100%" className="table table-striped table-bordered table-hover dataTables-example" id={tableId}>
        <thead>
        <tr>
          <th>Description</th>
          <th>Date</th>
          <th>Start</th>
          <th>Expiry</th>
        </tr>
        </thead>
        <tbody>
        </tbody>
      </table>
    )
  }
}

export default injectIntl(LicenseDetailsTable)



// WEBPACK FOOTER //
// ./src/routes/enterprise/components/LicenseDetailsTable.js